<form [formGroup]="ksuiteFormGroup">
    <div>
        <div>
            <h2>{{ 'Créez votre compte' | transloco }}</h2>
            <div>
                <mat-radio-group
                    [color]="'primary'"
                    [formControl]="account.get('legal_entity_type')"
                    class="entity-type"
                >
                    <mat-radio-button
                        *ngFor="let option of ksuiteFormGroupValues.legalEntityType.values"
                        [value]="option.value"
                    >
                        {{ option.label }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <div [hidden]="legalEntityTypeValue === 'individual'">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label [hidden]="legalEntityTypeValue !== 'company'"
                        >{{ 'Nom officiel de votre entreprise' | transloco }} *
                    </mat-label>
                    <mat-label [hidden]="legalEntityTypeValue !== 'association'"
                        >{{ 'Nom officiel de votre association' | transloco }} *
                    </mat-label>
                    <mat-label [hidden]="legalEntityTypeValue !== 'public_body'"
                        >{{ "Nom officiel de l'organisme" | transloco }} *
                    </mat-label>
                    <input [formControl]="account.get('name')" matInput />
                </mat-form-field>
            </div>

            <div *ngIf="account.get('name').hasError('unique')" class="error-msg-duplicate margin-bottom-20">
                <div class="icon icon-warning"></div>
                <div>
                    <span
                        [innerHTML]="
                            'Il existe deja un ou plusieurs compte(s) Infomaniak avec comme identifiant <strong> $name$ </strong>'
                                | transloco : { name: checkedValues.account.name | escapeHtml }
                        "
                        class="error-msg-duplicate__desc"
                    ></span>
                    <div class="padding-top-5">
                        <span (click)="useCheckedValueCallback(checkedValues.accountCallback)" class="link blue">
                            {{ 'Selectionner mon compte' | transloco }}
                        </span>
                        &nbsp;
                        <span (click)="clearErrors(account.get('name'))" class="link blue">{{
                            "Ignorer, ce n'est pas moi" | transloco
                        }}</span>
                    </div>
                </div>
            </div>

            <div class="split-mat-form-field">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Prenom' | transloco }}</mat-label>
                    <input [formControl]="user.get('firstname')" matInput />
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Nom' | transloco }}</mat-label>
                    <input [formControl]="user.get('lastname')" matInput />
                </mat-form-field>
            </div>

            <div *ngIf="user.get('lastname').hasError('unique')" class="error-msg-duplicate margin-bottom-20">
                <div class="icon icon-warning"></div>
                <div>
                    <span
                        [innerHTML]="
                            'Il existe deja un ou plusieurs utilisateur(s) Infomaniak avec comme nom <strong> $name$ </strong>'
                                | transloco : { name: checkedValues.userCallback.params[1] | escapeHtml }
                        "
                        class="error-msg-duplicate__desc"
                    ></span>
                    <div class="padding-top-5">
                        <span (click)="useCheckedValueCallback(checkedValues.userCallback)" class="link blue">
                            {{ 'Selectionner mon utilisateur' | transloco }}
                        </span>
                        &nbsp;
                        <span
                            (click)="clearErrors(user.get('lastname')); clearErrors(user.get('firstname'))"
                            class="link blue"
                            >{{ "Ignorer, ce n'est pas moi" | transloco }}</span
                        >
                    </div>
                </div>
            </div>

            <div class="split-field">
                <ik-phone-input
                    [autofocus]="false"
                    [defaultCode]="country"
                    [formControl]="user.get('reminder_phone')"
                    [invalidErrorMessage]="'Le numero de telephone est incorrect' | transloco"
                    [label]="('Telephone' | transloco) + ' *'"
                    [maxlength]="20"
                    [ngClass]="{ 'error-msg': user.get('reminder_phone').invalid }"
                    [removeBlur]="true"
                    [telOptions]="telOptions"
                ></ik-phone-input>
                <span
                    [tooltip]="
                        'Ce numero servira de telephone de recuperation pour renforcer la securite de votre compte.'
                            | transloco
                    "
                    class="cross icon icon-information"
                ></span>
            </div>

            <div class="rgpd-info">
                <span class="rgpd-info__text">
                    {{
                        'Votre numero sera uniquement utilise afin de securiser les informations de votre compte Infomaniak et en cas de perte de vos identifiants de connexion.'
                            | transloco
                    }}
                </span>
                <a
                    class="rgpd-info__link"
                    href="https://www.infomaniak.com/gtl/rgpd.confidentiality"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    {{ 'Pourquoi avons-nous besoin de ces informations ?' | transloco }}
                </a>
            </div>

            <div [class.formfield-has-error]="user.get('email')?.errors?.length > 0">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ 'Adresse mail de connexion' | transloco }}</mat-label>
                    <input [formControl]="user.get('email')" matInput />

                    <mat-error class="error-msg">
                        *
                        {{ "Cette adresse n'est pas disponible. Veuillez saisir une autre adresse mail." | transloco }}
                    </mat-error>

                    <mat-error *ngIf="user.get('email').hasError('unique')" class="error-msg-duplicate">
                        <div class="icon icon-warning"></div>
                        <div class="flex flex-column">
                            <span class="error-msg-duplicate__desc">
                                {{ 'Cette adresse mail semble deja liee a un compte Infomaniak.' | transloco }}
                            </span>
                            <span (click)="goToLogin()" class="link blue">{{
                                'Souhaitez-vous vous connecter ?' | transloco
                            }}</span>
                        </div>
                    </mat-error>
                </mat-form-field>
            </div>

            <div>
                <ik-password-input
                    (generate)="generate($event)"
                    [classes]="'ik-form-field ik-form-field--bigger'"
                    [formControl]="user.get('password')"
                    [iconGeneratePassword]="'icon-rotation-lock'"
                    [iconHidePassword]="' icon-eye-crossed'"
                    [iconSeePassword]="'icon-eye'"
                    [label]="'Mot de passe' | transloco"
                    [minLength]="8"
                    [placeholder]="'Mot de passe' | transloco"
                    [showGenerate]="true"
                    autocomplete="'password'"
                    matInput
                    name="password"
                    type="text"
                >
                </ik-password-input>
                <mat-error *ngIf="user.get('password').hasError('maxlength')" class="hintError">
                    {{ 'La taille maximum de ce champ est de 72 caracteres' | transloco }}
                </mat-error>
                <mat-error *ngIf="user.get('password').hasError('complexify')" class="hintError">
                    {{ 'validation_rule_password_unified_complexify' | transloco }}
                </mat-error>
                <mat-error
                    *ngIf="displayFormError"
                    [innerHTML]="getValidationErrorMessage()"
                    class="hintError"
                ></mat-error>
                <div class="margin-bottom-30 margin-top-30 validation">
                    <ik-validation-check
                        [description]="'Minuscule' | transloco"
                        [label]="'a'"
                        [tooltipMessage]="'Au moins une minuscule' | transloco"
                        [valid]="passwordValidation.lowerCase"
                    >
                    </ik-validation-check>
                    <ik-validation-check
                        [description]="'Majuscule' | transloco"
                        [label]="'A'"
                        [tooltipMessage]="'Au moins une majuscule' | transloco"
                        [valid]="passwordValidation.upperCase"
                    >
                    </ik-validation-check>
                    <ik-validation-check
                        [description]="'Chiffre' | transloco"
                        [label]="'0-9'"
                        [tooltipMessage]="'Au moins un chiffre' | transloco"
                        [valid]="passwordValidation.number"
                    >
                    </ik-validation-check>
                    <ik-validation-check
                        [description]="'Caracteres' | transloco"
                        [label]="'8+'"
                        [tooltipMessage]="'$number$ caracteres ou plus' | transloco : { number: 8 }"
                        [valid]="passwordValidation.characterCount"
                    >
                    </ik-validation-check>
                </div>
            </div>
        </div>

        <div class="padding-top-40">
            <h2>{{ 'Vos coordonnees de facturation' | transloco }}</h2>

            <div>
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ 'Adresse' | transloco }}</mat-label>
                    <input [formControl]="account.get('street')" matInput />
                </mat-form-field>
            </div>

            <div [class.split-field]="!displayStreet3">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ "Complement d'adresse" | transloco }}</mat-label>
                    <input #street2 [formControl]="account.get('street2')" matInput />
                </mat-form-field>
                <span
                    (click)="displayStreet()"
                    *ngIf="!displayStreet3"
                    [tooltip]="'Ajouter une nouvelle ligne' | transloco"
                    class="cross"
                >
                    <span>+</span>
                </span>
            </div>
            <div *ngIf="displayStreet3" [class.split-field]="displayStreet3">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ "Complement d'adresse" | transloco }}</mat-label>
                    <input [formControl]="account.get('street3')" matInput />
                </mat-form-field>
                <span (click)="hideStreet()" [tooltip]="'Supprimer la nouvelle ligne' | transloco" class="cross">
                    <span>-</span>
                </span>
            </div>

            <div class="split-mat-form-field">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Code Postal' | transloco }}</mat-label>
                    <input [formControl]="account.get('zip')" matInput />
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'Ville' | transloco }}</mat-label>
                    <input [formControl]="account.get('city')" matInput />
                </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="full-width ik-form-field ik-form-field--bigger">
                <mat-label>{{ 'Country' | transloco }}</mat-label>
                <input
                    (input)="filterCountries(account.get('country').value)"
                    [formControl]="account.get('country')"
                    [matAutocomplete]="paysAuto"
                    autocomplete="off"
                    matInput
                    name="country"
                    type="text"
                />
                <mat-autocomplete
                    #paysAuto="matAutocomplete"
                    (optionSelected)="handleCountry($event)"
                    autoActiveFirstOption
                >
                    <mat-option *ngFor="let country of filteredCountries" [value]="country">
                        {{ country.name | transloco }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="account.get('country_id').hasError('invalid')">
                    {{ "Ce pays n'est pas valide" | transloco }}
                </mat-error>
            </mat-form-field>

            <div *ngIf="showTVA()">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ 'Numero de TVA' | transloco }}</mat-label>
                    <span matPrefix class="mat-prefix" *ngIf="displayPrefixVAT">{{ VATPrefix(selectedCountry.short) }}</span>
                    <input
                        [formControl]="vatNumber"
                        autocomplete="vat_number"
                        matInput
                        (focusin)="isVatNumberFocused = true"
                        (focusout)="isVatNumberFocused = false"
                        type="text"
                    />
                    <mat-error *ngIf="vatNumber.hasError('vatFormat')">
                        *
                        {{ 'Le format du numero de TVA est invalide.' | transloco }}</mat-error
                    >
                    <mat-error *ngIf="vatNumber.hasError('vatCheck')">
                        *
                        {{ 'Le numero de TVA ne semble pas valide.' | transloco }}</mat-error
                    >
                </mat-form-field>
                <div *ngIf="showTVA() && isEU()" class="error-msg-duplicate margin-bottom-30">
                    <span class="cross icon icon-information blue align-items-baseline"></span>
                    <span>
                        {{
                            'Registered business can enter their tax identification number to remove tax charges from future bills.'
                                | transloco
                        }}</span
                    >
                </div>
            </div>
        </div>

        <signup-approvals-checks
            [formGroupRef]="ksuiteFormGroup"
            [isGroup]="ksuiteFormGroup.get('account').get('legal_entity_type').value !== 'individual'"
        ></signup-approvals-checks>

        <div class="padding-top-60 align-right block-button">
            <span (click)="goToLogin()" class="link blue padding-right-30">{{
                "J'ai deja un compte" | transloco
            }}</span>
            <button (click)="submit()" [color]="'primary'" mat-flat-button type="submit">Continuer</button>
        </div>
    </div>
</form>
